import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  Breadcrumbs,
  CssBaseline,
  Link,
} from '@mui/joy';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useParams, useNavigate } from 'react-router-dom';
import ShipmentTrackingContent from '../widgets/ShipmentTrackingContent';
import PermissionGate from '../../main/components/PermissionGate';
import { PERMISSIONS } from '../../main/context/AuthContext';
import { DirectionalMaterialThemeProvider } from '../../main/theme/DirectionalMaterialThemeProvider';

export default function ShipmentTrackingScreen() {
  const { t } = useTranslation('ui');
  const { shipmentId } = useParams();
  const navigate = useNavigate();

  return (
    <DirectionalMaterialThemeProvider>
      <CssBaseline />
      <PermissionGate permissions={[PERMISSIONS.TRACKING_EVENTS_LIST]}>
        <Box m={3}>
          <Box sx={{ mb: 3 }}>
            <Breadcrumbs separator={<KeyboardArrowRight />} aria-label="breadcrumbs">
              <Link color="neutral" href="/shipments">{t('nav.shipments')}</Link>
              <Link color="neutral" href="/shipment/tracking-events">{t('trackingEvent.breadcrumbList')}</Link>
              <Typography color="primary">{t('trackingEvent.shipmentTrackingTitle', { id: shipmentId })}</Typography>
            </Breadcrumbs>
          </Box>
          <Box component="main">
            <ShipmentTrackingContent
              shipmentId={shipmentId}
              variant="page"
              onBack={() => navigate(-1)}
            />
          </Box>
        </Box>
      </PermissionGate>
    </DirectionalMaterialThemeProvider>
  );
}
